import { useEffect, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Volume2 } from 'lucide-react'
import { isAudioUnlocked, unlockAudio } from '@/lib/soundManager'

export function AudioUnlockGate() {
  const { t } = useTranslation()
  const [needsUnlock, setNeedsUnlock] = useState(false)

  useEffect(() => {
    void unlockAudio().then(() => {
      if (!isAudioUnlocked()) setNeedsUnlock(true)
    })
  }, [])

  async function onActivate() {
    await unlockAudio()
    if (isAudioUnlocked()) setNeedsUnlock(false)
  }

  return (
    <AnimatePresence>
      {needsUnlock && (
        <motion.button
          type="button"
          onClick={onActivate}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed bottom-6 right-6 z-30 flex items-center gap-3 rounded-2xl border border-border bg-surface-1/90 px-4 py-3 shadow-2xl transition hover:border-brand-primary/40"
        >
          <span className="grid size-9 place-items-center rounded-xl bg-brand-primary/15 text-brand-primary">
            <Volume2 className="size-5" />
          </span>
          <span className="text-left">
            <span className="block text-sm font-medium text-ink">{t('audio.unlockTitle')}</span>
            <span className="block text-xs text-ink-subtle">{t('audio.unlockHint')}</span>
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  )
}
